import { jsx as _jsx } from "react/jsx-runtime";
import { Page, PageEmptyState, PageErrorState } from 'seagull';
import PageLoadingState from '~/components/PageLoadingState';
import RestfulWrapper from '~/components/RestfulWrapper/RestfulWrapper';
import { useStoreActions } from '~/store/store-context';
import { ActivityLogBusinessItem } from './ActivityLogBusinessItem';
const title = 'Activity logs';
function ActualActivityLogsPage(param) {
    let { data, loading } = param;
    const businessEntries = data.filter((entry)=>entry.isBusinessEntry());
    const hasData = businessEntries.length > 0;
    return /*#__PURE__*/ _jsx(Page, {
        header: title,
        skin: "secondary",
        testId: "activity-logs-page",
        loading: loading,
        children: hasData ? /*#__PURE__*/ _jsx("div", {
            "data-testid": "activity-logs-content",
            children: businessEntries.map((entry, index)=>/*#__PURE__*/ _jsx(ActivityLogBusinessItem, {
                    entry: entry,
                    isFirst: index === 0,
                    isLast: index === businessEntries.length - 1
                }, entry.id()))
        }) : /*#__PURE__*/ _jsx(PageEmptyState, {
            testId: "activity-logs-empty",
            illustration: null,
            title: "No activity logs yet",
            message: "Logs will appear here once there is activity in your business."
        })
    });
}
export default function ActivityLogsPage() {
    const { api } = useStoreActions();
    return /*#__PURE__*/ _jsx(RestfulWrapper, {
        fetch: api.business.getActivityLogs,
        renderChild: (param)=>{
            let { data, loading } = param;
            return /*#__PURE__*/ _jsx(ActualActivityLogsPage, {
                data: data,
                loading: loading
            });
        },
        renderLoader: ()=>/*#__PURE__*/ _jsx(PageLoadingState, {
                header: title,
                loading: true
            }),
        renderError: (param)=>{
            let { refresh } = param;
            return /*#__PURE__*/ _jsx(PageErrorState, {
                testId: "activity-logs-error",
                title: title,
                onRefresh: refresh
            });
        }
    });
}
